import { render } from "./PCInformacionSinRegistros.vue?vue&type=template&id=4f2c68fe&scoped=true"
import script from "./PCInformacionSinRegistros.vue?vue&type=script&lang=js"
export * from "./PCInformacionSinRegistros.vue?vue&type=script&lang=js"

import "./PCInformacionSinRegistros.vue?vue&type=style&index=0&id=4f2c68fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2c68fe"]])

export default __exports__